/**
 * Root layout: ThemeProvider + AuthProvider + SnackbarProvider + Outlet.
 * All authenticated child routes mount inside an AuthGate (in router.tsx).
 */
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useMemo } from 'react';
import { createAppTheme } from '@/theme/theme';
import { AuthProvider } from '@/auth/AuthContext';
import { SnackbarProvider } from '@/components/Snackbar';

export function RootLayout() {
  const theme = useMemo(() => createAppTheme(), []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <SnackbarProvider>
          <Outlet />
        </SnackbarProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
